import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast-container position-fixed bottom-0 start-0 p-2" }
const _hoisted_2 = { class: "toast-body" }
const _hoisted_3 = { class: "toast-body p-1" }
const _hoisted_4 = { class: "toast-body p-1" }

import { watch, reactive } from "vue";

interface IProps {
  erro?: string | null;
  progresso?: string | null;
  sucesso?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    erro: {},
    progresso: {},
    sucesso: {}
  },
  emits: ["limparErro", "limparProgresso", "limparSucesso"],
  setup(__props: any, { emit: __emit }) {

var props = __props;

var emit = __emit;

var controle = reactive({
  erro: "" as string,
  progresso: "" as string,
  sucesso: "" as string,
  exibeScrollToTop: false,
});

const exibeErro = (texto: string) => {
  controle.erro = texto;

  // setTimeout(() => {
  //   controle.erro = "";
  //   emit("limparErro");
  // }, 5000);
};
const limpaErro = () => {
  controle.erro = "";
  emit("limparErro");
};

const exibeProgresso = (texto: string) => {
  controle.progresso = texto;

  setTimeout(() => {
    controle.progresso = "";
    emit("limparProgresso");
  }, 2000);
};

const exibeSucesso = (texto: string) => {
  controle.sucesso = texto;

  setTimeout(() => {
    controle.sucesso = "";
    emit("limparSucesso");
  }, 3500);
};

watch(
  () => props.erro,
  async (novoValor) => {
    exibeErro(novoValor || "");
  },
);

watch(
  () => props.progresso,
  async (novoValor) => {
    exibeProgresso(novoValor || "");
  },
);

watch(
  () => props.sucesso,
  async (novoValor) => {
    exibeSucesso(novoValor || "");
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["toast text-white bg-danger", {show: _unref(controle).erro != null && _unref(controle).erro != ''}]),
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, [
      _createElementVNode("div", { class: "toast-header d-flex flex-row text-white bg-danger" }, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("label", { class: "flex-grow-1 fw-bold" }, "Erro", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn-sm btn-close-white btn-close",
          "data-bs-dismiss": "toast",
          "aria-label": "Close",
          onClick: limpaErro
        })
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(controle).erro), 1)
    ], 2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["toast text-white bg-primary", 'show']),
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(controle).progresso), 1)
      ])
    ], 512), [
      [_vShow, _unref(controle).progresso != null && _unref(controle).progresso != '']
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["toast text-white bg-success", 'show']),
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-check" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(controle).sucesso), 1)
      ])
    ], 512), [
      [_vShow, _unref(controle).sucesso != null && _unref(controle).sucesso != '']
    ])
  ]))
}
}

})